const initialState = {
    shareValue:[],
};
export const actionTypes = {
    REFRESH_SHARE_VAULE:"REFRESH_SHARE_VAULE",
};

export const actions = {
    refresh_share_value: function (data) {
        return {
            type: actionTypes.REFRESH_SHARE_VAULE,
            data
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.REFRESH_SHARE_VAULE:{
            return {...state,shareValue:action.data}
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/shareReducer.js